import React from 'react'

export type BadgeVariant = 'new' | 'contacted' | 'qualified' | 'proposal' | 'negotiation' | 'negotiating' | 'closed-won' | 'closed' | 'closed-lost' | 'lost' | 'active' | 'inactive'

interface StatusBadgeProps {
 status: BadgeVariant
 label?: string
}

const statusConfig: Record<BadgeVariant, { label: string; color: string }> = {
 new: { 
 label: 'Novo', 
 color: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' 
 },
 contacted: { 
 label: 'Em Contato', 
 color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' 
 },
 qualified: {
 label: 'Qualificado',
 color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
 },
 proposal: {
 label: 'Proposta',
 color: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
 },
 negotiation: {
 label: 'Negociação',
 color: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
 },
 negotiating: { 
 label: 'Negociação', 
 color: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' 
 },
 'closed-won': {
 label: 'Ganho',
 color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
 },
 closed: { 
 label: 'Fechado', 
 color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' 
 },
 'closed-lost': {
 label: 'Perdido',
 color: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
 },
 lost: { 
 label: 'Perdido', 
 color: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' 
 },
 active: { 
 label: 'Ativo', 
 color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' 
 },
 inactive: { 
 label: 'Inativo', 
 color: 'bg-surface text-foreground' 
 }
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
 const config = statusConfig[status]
 
 return (
 <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
 {label || config.label}
 </span>
 )
}

